import { render, staticRenderFns } from "./GalleryMedia.vue?vue&type=template&id=751d150e&scoped=true&"
import script from "./GalleryMedia.vue?vue&type=script&lang=js&"
export * from "./GalleryMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d150e",
  null
  
)

export default component.exports